import React from 'react';
import {Grid,Box,Typography} from '@mui/material'

const KrDetails = ({data}:any) => {
  return (
  //   <Grid container spacing={2}>
  //   <Grid item xs={12}>
  //     <Box display="flex" flexDirection="column" p={2} borderRadius={2} boxShadow={3} bgcolor="#f9f9f9">
        
  //       {[
  //         { label: 'شرح نتیجه', value: data?.name },
  //         { label: 'مسئول', value: data?.responsibleName },
  //         { label: 'سیستم امتیازدهی', value: data?.pointingSystemType },
  //         { label: 'نوع نتیجه', value: data?.okR_KeyResultType },
  //         { label: 'مقدارشروع', value: data.startValue === null ? 'خالی' : data?.startValue },
  //         { label: 'به 30% می رسد', value: data.threeTenthsValue === null ? 'خالی' : data?.threeTenthsValue },
  //         { label: 'به 70% می رسد', value: data.sevenTenthsValue === null ? 'خالی' : data?.sevenTenthsValue },
  //         { label: 'به 100% می رسد', value: data.oneValue === null ? 'خالی' : data?.oneValue },
  //         { label: 'وزن', value: data.score === null ? 'خالی' : data?.score },
  //         { label: 'تاریخ شروع', value: data.startDate === null ? 'خالی' : data?.startDate },
  //         { label: 'حداکثر تاریخ انجام', value: data.forceEndDate === null ? 'خالی' : data?.forceEndDate },
  //         //{ label: 'همسویی افقی', value: '' }, // فرض بر این است که مقدار خالی است
  //         { label: 'توضیحات', value: data.orgDescription === null ? '' : data?.orgDescription }
  //       ].map((item, index) => (
  //         <Box
  //           key={index}
  //           display="flex"
  //           alignItems="center"
  //           justifyContent="space-between"
  //           mb={1}
  //           p={1}
  //           bgcolor={index % 2 === 0 ? '#f0f8ff' : '#ffffff'}
  //           borderRadius={1}
  //           border="1px solid #00387C"
  //         >
  //           <Typography fontWeight={800} color="#00387C">
  //             {item.label}:
  //           </Typography>
  //           <Box 
  //             p={1}
  //           //   border="1px solid #00387C" 
  //             borderRadius={1} 
  //             bgcolor="#f9f9f9"
  //             display="flex"
  //             justifyContent="center"
  //             alignItems="center"
  //             minWidth="50px"
  //           >
  //             <Typography fontSize="16px" color="#555">
  //               {item.value}
  //             </Typography>
  //           </Box>
  //         </Box>
  //       ))}
  
  //     </Box>
  //   </Grid>
  // </Grid>
<Grid container spacing={2}>
  <Grid item xs={12}>
    <Box
      display="flex"
      flexDirection="column"
      p={2}
      borderRadius={2}
      boxShadow={3}
      bgcolor="#f9f9f9"
    >
      <Grid container spacing={2}>
        {[
          { label: 'شرح نتیجه', value: data?.name, singleColumn: true },
          { label: 'مسئول', value: data?.responsibleName },
          { label: 'سیستم امتیازدهی', value: data?.pointingSystemType },
          { label: 'نوع نتیجه', value: data?.okR_KeyResultType },
          { label: 'مقدارشروع', value: data.startValue === null ? 'خالی' : data?.startValue },
          { label: 'به 30% می رسد', value: data.threeTenthsValue === null ? 'خالی' : data?.threeTenthsValue },
          { label: 'به 70% می رسد', value: data.sevenTenthsValue === null ? 'خالی' : data?.sevenTenthsValue },
          { label: 'به 100% می رسد', value: data.oneValue === null ? 'خالی' : data?.oneValue },
          { label: 'وزن', value: data.score === null ? 'خالی' : data?.score },
          { label: 'تاریخ شروع', value: data.startDate === null ? 'خالی' : data?.startDate },
          { label: 'حداکثر تاریخ انجام', value: data.forceEndDate === null ? 'خالی' : data?.forceEndDate },
          { label: 'توضیحات', value: data.orgDescription === null ? '' : data?.orgDescription, singleColumn: true },
        ].map((item, index) => (
          <Grid item xs={item.singleColumn ? 12 : 6} key={index}>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="flex-start" // همه محتوا به سمت راست
              p={1}
              bgcolor={index % 2 === 0 ? '#f0f8ff' : '#ffffff'}
              borderRadius={1}
              border="1px solid #00387C"
              minHeight="60px"
            >
              {/* لیبل */}
              <Typography
                fontWeight={800}
                color="#00387C"
                style={{ marginLeft: '8px' }} // فاصله بین لیبل و مقدار
              >
                {item.label}:
              </Typography>
              {/* مقدار */}
              <Box
                p={1}
                borderRadius={1}
                bgcolor="#f9f9f9"
                display="flex"
                alignItems="center"
                minWidth="50px"
              >
                
                <Typography fontSize="13px" color="#555" textAlign="right">
                  {item.value}
                </Typography>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  </Grid>
</Grid>


  
  )
}

export default KrDetails